/* istanbul ignore file */

export const NewScopes = {
  veiveAdmin: 'system:admin:veive'
}
